import React from 'react'
import { SVGWithoutGluten, SVGWithoutLactose, SVGWithoutSugar, SVGArrow, SVGNew } from 'Components/SVGCollection'

import cn from 'classnames'
import cl from './Gallery.scss'
import cg from 'Scss/app.scss'
import gal from 'Components/Gallery/Gallery.scss'
import pc from 'Components/ProductCard/ProductCard.scss'

import ScrollableList from 'Components/ScrollableList/ScrollableList'
import uiEventEmitter, { UIEvents } from 'Utils/uiEventEmitter'
import { ProductListData } from 'Utils/api/gql/types'
import { productIngredientInfo, getSaleInfo, isDiscounted, isProductNew, getImageForSizeOrPlaceholder, GROBY_IMAGE_PLACEHOLDER } from 'Utils/helpers/productAttributeHelper'
import { ImageModal } from 'Components/Imagemodal';
import { SALE_BADGE_MINIMUM_AMOUNT } from 'Utils/helpers/constants';

type PropType = {
  product: ProductListData
}

type StateType = {
  selectedImageId: number | null
}

export const openImageModal = (imageUrls: string[], selectedId: number) => {
  const modalStyles: React.CSSProperties = {
    border: 0,
    borderRadius: 0,
    padding: 0,
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxShadow: 'none',
    overflow: 'visible'
  }
  uiEventEmitter.emit(UIEvents.SHOW_MODAL, <ImageModal defaultSelected={selectedId} imageUrls={imageUrls} />, () => {}, { style: modalStyles })
}

class Gallery extends React.Component<PropType, StateType> {
  scrollableList: ScrollableList | null = null
  public state: StateType = {
    selectedImageId: null
  }

  constructor (props: PropType) {
    super(props)

    this.state.selectedImageId = (props.product.images && props.product.images.length)
      ? 0
      : null
  }

  handleTransitionEnd = () => {
    this.scrollableList && this.scrollableList.setSizes()
  }

  componentDidMount() {
    uiEventEmitter.on(UIEvents.CARTPANEL_TRANSITION_END, this.handleTransitionEnd)
  }

  componentWillUnmount () {
    uiEventEmitter.off(UIEvents.CARTPANEL_TRANSITION_END, this.handleTransitionEnd)
  }

  renderImage () {
    const { product } = this.props

    const ingredientInfo = productIngredientInfo(product)
    const saleInfo = getSaleInfo(product)

    const selectedId = this.state.selectedImageId
    const fullImageURL = getImageForSizeOrPlaceholder(product, selectedId, 'full')
    const urls = this.props.product.images && this.props.product.images.map(image => image.conversions.full || '') || []

    return <div className={cn(cl.bigPictre, (fullImageURL === GROBY_IMAGE_PLACEHOLDER ? cl.placeholder : ''))}>
      <div id="bigPicture">
        <img
          src={fullImageURL}
          onClick={() => openImageModal(urls, selectedId || 0)}
        />
      </div>

      <span className={cn(cl.actionWrapper)}>
          {isDiscounted(product) && saleInfo.amount >= SALE_BADGE_MINIMUM_AMOUNT &&
            <span className={cn(cl.discount)}>
              <strong>{saleInfo.info && `${saleInfo.info}-ig`}</strong>
            </span>
          }
          {isProductNew(product) &&
            <span className={cn(pc.new)}>
              <SVGNew width="45" height="45" aria-hidden="true" />
            </span>
          }
      </span>

      <span className={cn(cl.freeWrapper)}>
          { ingredientInfo.gluten &&
            <span>
              <span className={cn(cg.showForSr)}>gluténmentes</span>
              <SVGWithoutGluten width="30" height="30" aria-hidden="true" />
            </span>
          }
          {ingredientInfo.lactose &&
            <span>
              <span className={cn(cg.showForSr)}>laktózmentes</span>
              <SVGWithoutLactose width="30" height="30" aria-hidden="true" />
            </span>
          }
          {ingredientInfo.sugar &&
            <span>
              <span className={cn(cg.showForSr)}>cukormentes</span>
              <SVGWithoutSugar width="30" height="30" aria-hidden="true" />
            </span>
          }
      </span>
    </div>
  }

  render () {
    const { product } = this.props
    const images = product.images && product.images.length > 1
      ? product.images
      : []

    return (
      <ScrollableList
        ref={ref => this.scrollableList = ref}
        mainContent={this.renderImage()}
        listItemsContent={images.map((_, i) =>
          <div key={i} className={cn(gal.thmb, { [gal.active]: i === this.state.selectedImageId })}>
            <img src={getImageForSizeOrPlaceholder(product, i, 'thumbnail')} onClick={() => this.setState({ selectedImageId: i })} />
          </div>
        )}
      />
    )
  }
}

export default Gallery
